export enum EmployeeRole {
  chief = 'chief', // 'AUTHOR_POSITION_ADMINISTRATOR',
  editor = 'editor', // 'AUTHOR_POSITION_EDITOR',
}
